module.exports = __webpack_public_path__ + "media/images/tiedye-1330b5c9.gif";